import { Text, Rectangle, RenderObject } from '@core/render/render-objects';
import { BaseNoteAnimation, type AnimationContext } from './base';
import { registerAnimation } from './registry';
import * as af from '@math/animation/anim-math'; //Anim functions
import easingFunctions from '@math/animation/easing';

const ef = easingFunctions;

export class PressAnimation extends BaseNoteAnimation {
    render(ctx: AnimationContext): RenderObject[] {
        const { x, y, width, height, color, progress, phase, block } = ctx;

        let rect = new Rectangle(x, y, width, height, { fillColor: color });

        switch (phase) {
            case 'attack': {
                rect.opacity = af.lerp(0, 1, progress);
                return this.markNonLayout([rect]);
            }
            case 'decay': {
                let bounceCurve = new af.FloatCurve([
                    [0, 0, ef.easeOutQuad],
                    [0.3, height, ef.easeInOutQuad],
                    [1, 0, ef.linear],
                ]);
                rect.y = y + bounceCurve.valAt(progress);
                rect.opacity = 1;
                return this.markNonLayout([rect]);
            }
            case 'sustain':
                rect.y = y;
                rect.opacity = 1;
                return this.markNonLayout([rect]);
            case 'release': {
                rect.y = y;
                rect.opacity = af.lerp(1, 0, progress);
                return this.markNonLayout([rect]);
            }
            default:
                return [];
        }
    }
}

registerAnimation({ name: 'press', label: 'Press', class: PressAnimation });
